<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="关账"
    :visible.sync="dialogVisible"
    width="440px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="80px">
        <el-form-item label="关账类型" required>
          <el-radio-group v-model="form.closeType" @input="handleChange">
            <el-radio :label="1">{{ !active ? '按ETA' : '按创建时间' }}</el-radio>
            <el-radio :label="2">按提单号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.closeType === 1" :label="!active ? 'ETA' : '创建时间'" prop="date">
          <el-date-picker
            v-model="form.date"
            style="width: 100%"
            type="daterange"
            range-separator="至"
            align="center"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            unlink-panels
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-else label="提单号" prop="mblNos">
          <BaseMutiInput
            ref="baseMutiInput"
            v-model="form.mblNos"
            :default="form.mblNos"
          ></BaseMutiInput>
        </el-form-item>
        <el-form-item label="关账号" prop="closeNo">
          <el-input v-model="form.closeNo" placeholder="请输入关账号" />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>
<script>
import { grossProfitCloseClePic, CloseOtherServiceAmount } from '@/api/fee'
const BaseMutiInput = () => import('@/components/base/BaseMutiInput.vue')
export default {
  components: { BaseMutiInput },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      form: {
        date: '',
        closeNo: '',
        mblNos: '',
        closeType: 1
      },
      loading: false
    }
  },
  computed: {
    rules() {
      return {
        date: [
          { required: true, message: `请选择${!this.active ? 'ETA' : '创建时间'}`, trigger: 'blur' }
        ],
        closeNo: [
          { required: true, message: '请输入关账号', trigger: 'blur' }
        ],
        mblNos: [
          { required: true, message: '请输入提单号', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    reset() {
      this.form = this.$options.data().form
      this.$refs['form'].resetFields()
    },
    cancel() {
      this.reset()
      this.$emit('cancel')
    },
    handleChange() {
      this.form.date = ''
      this.$refs.baseMutiInput?.reset()
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.loading = true
          try {
            const params = {
              closeNo: this.form.closeNo,
              mblNos: this.form.closeType === 2 ? this.form.mblNos : undefined,
              startDate: this.form.closeType === 1 ? this.form.date[0] : undefined,
              endDate: this.form.closeType === 1 ? this.form.date[1] : undefined
            }
            let res
            !this.active && (res = await grossProfitCloseClePic(params))
            this.active && (res = await CloseOtherServiceAmount(params))
            this.loading = false
            if (res.success) {
              this.$message.success('操作成功')
              this.$emit('ok')
              this.reset()
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            this.loading = false
            console.error(error)
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  .header {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .data {
    width: 1160px;
    height: auto;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    box-sizing: border-box;
    .fTable {
      height: 448px;
    }
    .select {
      margin-top: 20px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      span {
        color:  rgb(18,88,188);
      }
    }
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
